module.exports = __webpack_public_path__ + "media/images/flags/mu-c4aa8b71da07d356eaf52ca5b44374ab.svg";